<app-details-historie-card
  testId="tf-historie"
  [title]="'testCases.form.sections.history.title' | translate"
  [subtitle]="'testCases.form.sections.history.subtitle' | translate"
  [tabs]="reiter()"
  [(activeTab)]="aktiverReiter"
>
  <ng-template appDetailsHistoriePanel="versionen">
    <app-version-diff-list
      [vonVersion]="vorversion()?.version ?? null"
      [zuVersion]="current()?.version ?? null"
      [autorName]="vorversion()?.createdByName ?? null"
      [geaendertAm]="vorversion()?.createdAt ?? null"
      [felder]="geaenderteFelder()"
      [status]="versionStatus()"
      (retry)="ladeVorversion()"
    />
  </ng-template>
  <ng-template appDetailsHistoriePanel="uebergabe">
    <app-uebergabe-panel
      testIdPrefix="tf"
      [messageRequired]="true"
      [chain]="stufen()"
      [closed]="kette()?.closed ?? false"
      [closedAt]="kette()?.closedAt ?? null"
      [activeSince]="seit()"
      [vorlagen]="vorlagen()"
      [personOptions]="auswahl()"
      [readonly]="readonly()"
      [disabledReason]="sperrGrund()"
      [handOffDisabledReason]="uebergebenSperrGrund()"
      [busy]="beschaeftigt()"
      [errorMessage]="aktionsFehler()"
      [status]="ketteStatus()"
      [entwurf]="entwurf()"
      (entwurfChange)="entwurfGeaendert($event)"
      (handOff)="uebergeben($event)"
      (close)="abschliessen()"
      (reopen)="wiederOeffnen()"
      (skip)="ueberspringen($event)"
      (retry)="ladeKette()"
    />
  </ng-template>
  <ng-template appDetailsHistoriePanel="verlauf">
    <app-verlauf-liste [eintraege]="verlaufEintraege()" [status]="verlaufStatus()" (retry)="ladeVerlauf()" />
    @if (verlaufGekuerzt() && verlaufStatus() === 'bereit') {
      <p class="tf-historie__gekuerzt" data-testid="tf-verlauf-gekuerzt">
        {{ 'testCases.form.activity.truncated' | translate }}
      </p>
    }
  </ng-template>
  <ng-template appDetailsHistoriePanel="notizen">
    <ng-content />
  </ng-template>
</app-details-historie-card>
